<div class="input-group">
    <input type="text" class="form-control" x-ng-model="choosedDirectory" x-field-errors="" disabled="disabled">
      <span class="input-group-btn">
          <button class="btn btn-primary" type="button" x-ng-click="open()">{{ 'file.browser.choose' | i18n }}</button>
      </span>
</div>